import { parseDanishCivilDate } from '@/lib/danishDate';

/** Matches documents_document_title_len / documents_document_author_len. */
export const DOCUMENT_INFO_TEXT_MAX = 200;

export type DocumentInfoField = 'title' | 'date' | 'author';

const DANISH_MONTHS = [
  'januar',
  'februar',
  'marts',
  'april',
  'maj',
  'juni',
  'juli',
  'august',
  'september',
  'oktober',
  'november',
  'december',
] as const;

const NUMERIC_DATE = /(\d{1,2}[.\-/]\d{1,2}[.\-/]\d{4}|\d{4}-\d{2}-\d{2})/;
const NAMED_DATE = new RegExp(`(\\d{1,2})\\.?\\s+(${DANISH_MONTHS.join('|')})\\s+(\\d{4})`, 'i');

export function normalizeDocumentInfoText(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

/** Read a civil date (YYYY-MM-DD) out of a text selection. */
export function documentDateFromSelection(quote: string): string | null {
  const trimmed = quote.trim();
  const direct = parseDanishCivilDate(trimmed);
  if (direct) return direct;

  const numeric = trimmed.match(NUMERIC_DATE);
  if (numeric) {
    const parsed = parseDanishCivilDate(numeric[1]);
    if (parsed) return parsed;
  }

  const named = trimmed.match(NAMED_DATE);
  if (!named) return null;
  const month = DANISH_MONTHS.indexOf(named[2].toLowerCase() as (typeof DANISH_MONTHS)[number]) + 1;
  if (month < 1) return null;
  return parseDanishCivilDate(`${named[1]}.${month}.${named[3]}`);
}

/**
 * The Dokument info query or save failed because the migration has not been
 * applied (missing column, or update_patient_document still has the old args).
 */
export function isDocumentInfoSchemaError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const code = 'code' in error && error.code != null ? String(error.code) : '';
  const message = 'message' in error && error.message != null ? String(error.message) : '';
  if (code === '42703' || code === 'PGRST204') return true;
  if (
    code === 'PGRST202' &&
    /update_patient_document|document_title|document_author/.test(message)
  ) {
    return true;
  }
  return /column\s+\S*document_(title|author|date)\s+does not exist/i.test(message);
}
